const caseStudies = [
  {
    title: "V Shred",
    description: "Designing a flagship training app with a multi-tier membership strategy",
    tags: ["Strategy", "UX/UI", "Mobile App"],
    images: [
      require('../assets/vshred.png')
    ]
  },
  {
    title: "Wiley",
    description: "Building a journey mapping process for improved understanding of customer behaviors and enabling greater data backed decisions at a leading publishing company",
    tags: ["EdTech", "Platform", "Design"],
    images: [
      require('../assets/cjm3.png')
    ]
  },
  {
    title: "Telus Agronomy",
    description: "Designing a data heavy crop planning mobile app for farmers, agronomists, and agriculture retail sites, taking into account offline access, outdoor conditions, and limited technology proficiency",
    tags: ["Agriculture", "Data", "Innovation"],
    images: [
      "https://via.placeholder.com/600x400/cccccc/888888?text=+"
    ]
  },
  {
    title: "Regal Theaters",
    description: "Placeholder description for Regal Theaters case study.",
    tags: ["Entertainment", "Mobile", "Ticketing"],
    images: [
      "https://via.placeholder.com/600x400/cccccc/888888?text=+"
    ]
  },
  {
    title: "Koodo Mobile",
    description: "Placeholder description for Koodo Mobile case study.",
    tags: ["Telecom", "App", "Customer Experience"],
    images: [
      "https://via.placeholder.com/600x400/cccccc/888888?text=+"
    ]
  },
  {
    title: "Best Western",
    description: "Placeholder description for Best Western case study.",
    tags: ["Hospitality", "Booking", "Web"],
    images: [
      "https://via.placeholder.com/600x400/cccccc/888888?text=+"
    ]
  },
  {
    title: "Irobot",
    description: "Placeholder description for Irobot case study.",
    tags: ["Robotics", "IoT", "Smart Home"],
    images: [
      "https://via.placeholder.com/600x400/cccccc/888888?text=+"
    ]
  },
  {
    title: "Nike",
    description: "Placeholder description for Nike case study.",
    tags: ["Retail", "E-commerce", "Brand"],
    images: [
      "https://via.placeholder.com/600x400/cccccc/888888?text=+"
    ]
  }
];

export default caseStudies; 